import {
  AccidentFollowUpStateTypes,
  AccidentFollowUpActionTypes,
} from "./AccidentFollowUp.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AccidentFollowUpStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const AccidentFollowUpReducer = (
  state: AccidentFollowUpStateTypes = INITIAL_STATE,
  action: any
): AccidentFollowUpStateTypes => {
  switch (action.type) {
    case AccidentFollowUpActionTypes.FETCH_ALL_ACCIDENT_FOLLOW_UP:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AccidentFollowUpActionTypes.FETCH_ALL_ACCIDENT_FOLLOW_UP_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AccidentFollowUpActionTypes.FETCH_ALL_ACCIDENT_FOLLOW_UP_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AccidentFollowUpActionTypes.FETCH_ALL_ACCIDENT_FOLLOW_UP_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case AccidentFollowUpActionTypes.FETCH_ONE_ACCIDENT_FOLLOW_UP:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case AccidentFollowUpActionTypes.FETCH_ONE_ACCIDENT_FOLLOW_UP_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AccidentFollowUpActionTypes.FETCH_ONE_ACCIDENT_FOLLOW_UP_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AccidentFollowUpActionTypes.FETCH_ONE_ACCIDENT_FOLLOW_UP_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AccidentFollowUpReducer;
